var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHowToCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6562 58.5C22.4563 58.5 17.6562 56.1667 16.1562 55C15.271 54.43 14.7874 52.4292 14.6562 51.5L10.6562 14C12.4896 15.1667 18.8562 17.5 29.6562 17.5C40.4562 17.5 46.8229 15.8333 48.6562 15C47.3229 26.6667 44.4562 50.3 43.6562 51.5C43.6562 53.9 42.9896 54.8333 42.6562 55C41.3229 56.1667 36.8563 58.5 29.6562 58.5Z",
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 50C23.6562 55.5 35.1562 55.5 43.6562 50.5",
    stroke: "#2D2926",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6567 11C52.4567 12.6 49.8234 14.3333 48.1567 15C46.6569 15.8333 41.0572 17.5 30.6567 17.5C20.2563 17.5 12.6568 15.5 10.6567 14C8.65667 12.5 8.65675 12 9.65672 11C8.85672 8.6 11.3234 7.33333 12.6567 7C12.6567 6.66667 12.7567 5.6 13.1567 4C14.6567 2.5 17.6567 1 30.6567 1C41.0567 1 45.3234 3 46.1567 4C46.3234 4.16667 46.6567 5 46.6567 7C50.1567 8.5 50.1567 9.5 49.6567 11Z",
    fill: "#2D2926",
    stroke: "#2D2926",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 5C18.1562 8 40.1562 8 45.1562 5M11.1562 10.5C19.2912 15.3099 39.5292 14.821 48.1562 10.5",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHowToCup);
export default __webpack_public_path__ + "static/media/iconHowToCup.a75b5cf58b8453ad20bda76dc1dfb167.svg";
export { ForwardRef as ReactComponent };